//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { useEffect, useState } from 'react';

import getAngularInjector from '@react-bridge/getAngularInjector';
import { getStateName } from '@react-bridge/wrappers/navigation';

import { RoutableStateName } from 'app/top-level-states';

const STATE_CHANGED_EVENT = '$stateChangeSuccess';
const ROUTES_WITH_HIDDEN_CONTENT_DRAWER_TRIGGER: RoutableStateName[] = [
  'instagramAccount',
  'tiktok',
  'syndication.summary',
];

export const useShouldHideContentDrawerRoutesConfig = () => {
  const [stateName, setStateName] = useState(getStateName());

  useEffect(() => {
    const $rootScope = getAngularInjector().get('$rootScope');
    $rootScope.$on(STATE_CHANGED_EVENT, () => setStateName(getStateName()));
  }, []);

  return ROUTES_WITH_HIDDEN_CONTENT_DRAWER_TRIGGER.some((state) =>
    stateName.startsWith(state),
  );
};
